import { css } from '@microsoft/fast-element';
export const foundationUrlInputStyles = (context, definition) => css `
  .container {
    position: relative;
    width: 100%;
  }

  .url-input {
    position: relative;
    width: 100%;
  }

  .url-input-link {
    position: absolute;
    left: 10px;
    top: 24px;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
